module.exports = "  <div class=\"\">\r\n    <h1>Document Search</h1>\r\n    <ng-content></ng-content>\r\n  </div>"